/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {ReactElement, useEffect, useState} from 'react';
import {
  Autocomplete,
  TextField,
  Checkbox,
  MenuItem,
  Typography,
  Badge,
  FormHelperText
} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import {AutoCompleteField, FormHelperTextP} from './SelectInputMultiStyle';

export interface SelectInputProps {
  field?: any;
  sx?: any;
  options: Array<any>;
  name: string;
  multiple?: boolean;
  optionValueKey?: string;
  optionLabelKey?: string;
  enableDefaultOption?: boolean;
  errorMessage?: string;
  TextErrorMessage?: string;
  setValue?: string;
  onChange?: (e: any) => void;
  onChangeCallback?: any;
  label?: string;
  placeholder?: string;
  error?: any;
  value?: any;
  fullWidth?: any;
  disabled?: boolean;
  selectProps?: any;
  onOpenCallback?: any;
  fetchOptionsFromOnOpenTrigger?: boolean;
  MenuProps?: any;
}

const SelectInputMultiAutoCompleteLimitTag = (
  props: SelectInputProps
): ReactElement => {
  const {
    options = [],
    optionValueKey = 'value',
    optionLabelKey = 'label',
    enableDefaultOption,
    placeholder,
    error,
    errorMessage,
    TextErrorMessage,
    value = '',
    label,
    fullWidth,
    disabled = false,
    onOpenCallback,
    onChangeCallback,
    fetchOptionsFromOnOpenTrigger,
    sx,
    ...rest
  } = props;
  const theme = useTheme();
  const [currentValue, setCurrentValue] = useState<any[]>(value || []);
  const [optionsList, setOptionsList] = useState<any>([]);

  useEffect(() => {
    setCurrentValue(value || []);
  }, [value]);

  useEffect(() => {
    const optionObj: any = [...options];

    if (optionObj.find((item: any) => item.value?.toLowerCase()?.replace(' ', '_') !== 'select_all')) {
      optionObj.unshift({label: 'Select All', value: 'Select All'});
    }
    setOptionsList(optionObj);
  }, [options]);

  const handleChange = (event: any, value: any) => {
    const isSelectAllClicked = value?.some(
      (item: any) => item.value?.toLowerCase()?.replace(' ', '_') === 'select_all'
    );

    if (isSelectAllClicked) {
      const newValue =
        currentValue?.length < options?.length
          ? optionsList?.filter((item: any) => item.value?.toLowerCase()?.replace(' ', '_') !== 'select_all')
          : [];

      setCurrentValue(newValue);
      onChangeCallback?.(newValue);
    } else {
      setCurrentValue(value);
      onChangeCallback?.(value);
    }
  };

  return (
    <>
      <AutoCompleteField
        disabled={disabled}
        limitTags={2}
        multiple
        disableCloseOnSelect
        options={optionsList || []}
        getOptionLabel={(option: any) => option[optionLabelKey] || ''}
        value={currentValue}
        onChange={handleChange}
        isOptionEqualToValue={(option: any, value: any) =>
          option[optionValueKey] === value[optionValueKey]
        }
        renderOption={(props, option: any, {selected}) => {
          const selected_checkbox =
            (option[optionValueKey]?.toLowerCase()?.replace(' ', '_') == 'select_all' &&
              currentValue?.length == options?.length) ||
            selected;
          return (
            <MenuItem {...props}>
              <Checkbox checked={selected_checkbox} />
              <Typography>{option[optionLabelKey]}</Typography>
            </MenuItem>
          );
        }}
        renderInput={params => (
          <TextField {...params} label={placeholder} placeholder={''} />
        )}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#0000003b',
            borderWidth: '1.8px'
          },
          // '&.MuiAutocomplete-root.MuiAutocomplete-hasClearIcon.MuiAutocomplete-hasPopupIcon': {
          //     height: '30px !important', // Fixed height when all three classes are applied
          // },
          ...sx
        }}
        {...rest}
      />
      {error && <FormHelperTextP>{errorMessage}</FormHelperTextP>}
      {error && <FormHelperText error>{TextErrorMessage}</FormHelperText>}
    </>
  );
};

export default SelectInputMultiAutoCompleteLimitTag;
